/* ============================================================
   Nourish FAQ Center — faq-center.js  (v3: expand-in-place cards)
   Powers sections/faq-hero.liquid + sections/faq-topic.liquid
   - topic cards built from the faq-topic sections on the page
   - clicking a card animates open a full-width panel right under
     that card's row, with the topic's questions inside
   - clicking the card again collapses it; questions animate too
   - live search across every question with highlighting
   - deep links: #topic-slug opens that card's panel
   ============================================================ */
(function () {
    'use strict';

    /* the hero and every topic section include this file, so it executes
       multiple times per page — only the first run may set up state */
    if (window.__nourishFaqCenter) return;
    window.__nourishFaqCenter = true;

    document.documentElement.classList.add('faq-js');

    var hero = null;
    var topics = [];
    var index = [];
    var input = null;
    var expander = null;
    var current = null;

    function reducedMotion() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* ---------- clicks (event delegation, survives clones) ---------- */
    document.addEventListener('click', function (e) {
        var qBtn = e.target.closest('[data-faqx-q]');
        if (qBtn) {
            var item = qBtn.closest('[data-faqx-item]');
            if (item) slideToggleItem(item, qBtn);
            return;
        }
        var card = e.target.closest('[data-faqx-card]');
        if (card) { activate(card.getAttribute('data-topic'), true); return; }

        /* click-to-enlarge for answer images */
        var lb = e.target.closest('.faqx-lightbox');
        if (lb) { lb.parentNode.removeChild(lb); return; }
        var zimg = e.target.closest('.faqx-item__media img');
        if (zimg) {
            var overlay = document.createElement('div');
            overlay.className = 'faqx-lightbox';
            var big = document.createElement('img');
            big.src = zimg.currentSrc || zimg.src;
            big.alt = zimg.alt || '';
            overlay.appendChild(big);
            document.body.appendChild(overlay);
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            var lb = document.querySelector('.faqx-lightbox');
            if (lb) lb.parentNode.removeChild(lb);
        }
    });

    function $all(sel, ctx) {
        return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
    }

    /* ---------- question open/close with grow animation ---------- */
    function slideToggleItem(item, qBtn) {
        var a = item.querySelector('.faqx-item__a');
        var isOpen = item.classList.contains('is-open');
        if (qBtn) qBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (!a || reducedMotion()) {
            item.classList.toggle('is-open');
            return;
        }
        if (isOpen) {
            a.style.display = 'block';
            a.style.overflow = 'hidden';
            a.style.height = a.scrollHeight + 'px';
            void a.offsetHeight;
            a.style.transition = 'height 0.28s ease, opacity 0.28s ease';
            a.style.height = '0px';
            a.style.opacity = '0';
            setTimeout(function () {
                item.classList.remove('is-open');
                a.style.cssText = '';
            }, 300);
        } else {
            item.classList.add('is-open');
            var h = a.scrollHeight;
            a.style.overflow = 'hidden';
            a.style.height = '0px';
            a.style.opacity = '0';
            void a.offsetHeight;
            a.style.transition = 'height 0.28s ease, opacity 0.28s ease';
            a.style.height = h + 'px';
            a.style.opacity = '1';
            setTimeout(function () { a.style.cssText = ''; }, 320);
        }
    }

    /* move each image to its [image-N] marker inside the answer text */
    function placeInlineImages() {
        $all('[data-faqx-topic] [data-faqx-item]').forEach(function (item) {
            $all('.faqx-item__abody p', item).forEach(function (p) {
                var m = p.textContent.trim().match(/^\[image-(\d+)\]$/);
                if (!m) return;
                var media = item.querySelector('.faqx-item__media[data-faqx-img="' + m[1] + '"]');
                if (media) {
                    p.parentNode.replaceChild(media, p);
                } else {
                    p.parentNode.removeChild(p); /* marker with no image uploaded yet */
                }
            });
        });
    }

    function init() {
        hero = document.querySelector('[data-faqx-hero]');
        topics = $all('[data-faqx-topic]');
        if (!topics.length) return;
        placeInlineImages();
        current = null;
        if (expander && expander.parentNode) expander.parentNode.removeChild(expander);
        expander = null;

        if (hero) {
            buildCards();
            input = hero.querySelector('[data-faqx-search]');
            if (input) {
                buildIndex();
                input.addEventListener('input', debounce(onSearch, 120));
                var clearBtn = hero.querySelector('[data-faqx-clear]');
                if (clearBtn) {
                    clearBtn.addEventListener('click', function () {
                        input.value = '';
                        onSearch();
                        input.focus();
                    });
                }
            }
        }

        /* start with everything closed; only a #hash deep link opens a topic */
        var slug = (location.hash || '').replace('#', '');
        if (slug && (slug === '__all' || findTopic(slug))) {
            activate(slug, false);
        }
    }

    function findTopic(slug) {
        for (var i = 0; i < topics.length; i++) {
            if (topics[i].getAttribute('data-slug') === slug) return topics[i];
        }
        return null;
    }

    /* ---------- topic cards ---------- */
    function buildCards() {
        var grid = hero.querySelector('[data-faqx-cards]');
        if (!grid) return;
        grid.innerHTML = '';

        topics.forEach(function (t) {
            var iconTpl = t.querySelector('template[data-faqx-icon]');
            grid.appendChild(makeCard({
                slug: t.getAttribute('data-slug'),
                title: t.getAttribute('data-title'),
                desc: t.getAttribute('data-desc') || '',
                color: t.getAttribute('data-color') || '#4e86a2',
                count: $all('[data-faqx-item]', t).length,
                iconHtml: iconTpl ? iconTpl.innerHTML : ''
            }));
        });

        if (hero.getAttribute('data-show-all') === 'true') {
            var allTpl = hero.querySelector('template[data-faqx-allicon]');
            grid.appendChild(makeCard({
                slug: '__all',
                title: hero.getAttribute('data-all-label') || 'All Questions',
                desc: 'Browse everything in one place.',
                color: '#3d3b3b',
                count: $all('[data-faqx-item]').length,
                iconHtml: allTpl ? allTpl.innerHTML : ''
            }));
        }
    }

    function makeCard(o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'faqx-card';
        b.setAttribute('data-faqx-card', '');
        b.setAttribute('data-topic', o.slug);
        b.style.setProperty('--faqx-accent', o.color);
        b.innerHTML =
            '<span class="faqx-card__icon" aria-hidden="true">' + o.iconHtml + '</span>' +
            '<span class="faqx-card__body">' +
            '<span class="faqx-card__title"></span>' +
            '<span class="faqx-card__desc"></span>' +
            '<span class="faqx-card__count">' + o.count + (o.count === 1 ? ' question' : ' questions') + '</span>' +
            '</span>';
        b.querySelector('.faqx-card__title').textContent = o.title;
        b.querySelector('.faqx-card__desc').textContent = o.desc;
        return b;
    }

    /* Shopify's theme editor treats elements carrying data-shopify* attributes
       as clickable blocks (first click selects the block instead of acting).
       Cloned content must not carry them. */
    function stripEditorAttrs(root) {
        var nodes = [root].concat($all('*', root));
        nodes.forEach(function (el) {
            if (!el.attributes) return;
            for (var i = el.attributes.length - 1; i >= 0; i--) {
                var n = el.attributes[i].name;
                if (n.indexOf('data-shopify') === 0) el.removeAttribute(n);
            }
        });
    }

    /* ---------- expand-in-place panel ---------- */
    function panelContentFor(slug) {
        var frag = document.createDocumentFragment();
        var list = slug === '__all' ? topics : [findTopic(slug)];
        list.forEach(function (t) {
            if (!t) return;
            var inner = t.querySelector('.faqx-topic__inner');
            if (!inner) return;
            var wrap = document.createElement('div');
            wrap.className = 'faqx-expander__topic';
            wrap.style.setProperty('--faqx-accent', t.getAttribute('data-color') || '#4e86a2');
            var clone = inner.cloneNode(true);
            stripEditorAttrs(clone);
            $all('[id]', clone).forEach(function (el) { el.removeAttribute('id'); });
            clone.removeAttribute('id');
            $all('[data-faqx-item]', clone).forEach(function (it) { it.classList.remove('is-open'); });
            var head = clone.querySelector('header');
            if (head) head.parentNode.removeChild(head);
            if (slug === '__all') {
                var chip = document.createElement('span');
                chip.className = 'faqx-chip';
                chip.textContent = t.getAttribute('data-title');
                clone.insertBefore(chip, clone.firstChild);
            }
            wrap.appendChild(clone);
            frag.appendChild(wrap);
        });
        return frag;
    }

    function insertionPointFor(card) {
        /* place the panel after the last card in the clicked card's row */
        var grid = card.parentNode;
        var top = card.offsetTop;
        var cards = $all('[data-faqx-card]', grid);
        for (var i = 0; i < cards.length; i++) {
            if (cards[i].offsetTop > top + 5) return cards[i];
        }
        return null; /* append at end */
    }

    function openPanel(slug, animate) {
        var grid = hero ? hero.querySelector('[data-faqx-cards]') : null;
        var card = grid ? grid.querySelector('[data-faqx-card][data-topic="' + slug + '"]') : null;
        if (!grid || !card) return;

        if (!expander) {
            expander = document.createElement('div');
            expander.className = 'faqx-expander';
            expander.setAttribute('data-faqx-expander', '');
        }
        if (expander.parentNode) expander.parentNode.removeChild(expander);
        expander.innerHTML = '';
        expander.appendChild(panelContentFor(slug));
        expander.style.setProperty('--faqx-accent', card.style.getPropertyValue('--faqx-accent') || '#4e86a2');
        grid.insertBefore(expander, insertionPointFor(card));

        if (!animate || reducedMotion()) {
            expander.classList.add('is-open');
            expander.style.height = 'auto';
            return;
        }
        expander.classList.add('is-open');
        expander.style.overflow = 'hidden';
        expander.style.height = '0px';
        expander.style.opacity = '0';
        void expander.offsetHeight;
        var h = expander.scrollHeight;
        expander.style.transition = 'height 0.7s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.55s ease';
        expander.style.height = h + 'px';
        expander.style.opacity = '1';
        setTimeout(function () {
            expander.style.transition = '';
            expander.style.height = 'auto';
            expander.style.overflow = '';
            expander.style.opacity = '';
        }, 720);
    }


    function closePanel(animate) {
        if (!expander || !expander.parentNode) { current = null; return; }
        var ex = expander;
        if (!animate || reducedMotion()) {
            ex.classList.remove('is-open');
            if (ex.parentNode) ex.parentNode.removeChild(ex);
            return;
        }
        ex.style.overflow = 'hidden';
        ex.style.height = ex.scrollHeight + 'px';
        void ex.offsetHeight;
        ex.style.transition = 'height 0.45s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.3s ease';
        ex.style.height = '0px';
        ex.style.opacity = '0';
        setTimeout(function () {
            ex.classList.remove('is-open');
            ex.style.cssText = '';
            if (ex.parentNode) ex.parentNode.removeChild(ex);
        }, 470);
    }

    /* ---------- topic switching ---------- */
    function activate(slug, fromClick) {
        clearSearchUI();

        /* clicking the open card again = collapse everything */
        if (fromClick && current === slug) {
            current = null;
            closePanel(true);
            markCards(null);
            if (history.replaceState) history.replaceState(null, '', location.pathname + location.search);
            return;
        }

        var switching = current !== null;
        current = slug;
        markCards(slug);
        if (switching) closePanel(false);
        openPanel(slug, true);

        if (fromClick && history.replaceState) {
            history.replaceState(null, '', '#' + (slug === '__all' ? '' : slug));
        }
    }

    function markCards(slug) {
        if (!hero) return;
        $all('[data-faqx-card]', hero).forEach(function (c) {
            c.classList.toggle('is-active', slug !== null && c.getAttribute('data-topic') === slug);
        });
    }

    /* ---------- search ---------- */
    function buildIndex() {
        index = [];
        topics.forEach(function (t) {
            var title = t.getAttribute('data-title');
            var color = t.getAttribute('data-color') || '#4e86a2';
            $all('[data-faqx-item]', t).forEach(function (item) {
                var qEl = item.querySelector('.faqx-item__qtext');
                var aEl = item.querySelector('.faqx-item__abody');
                index.push({
                    el: item,
                    q: qEl ? qEl.textContent.toLowerCase() : '',
                    a: aEl ? aEl.textContent.toLowerCase() : '',
                    topic: title,
                    color: color
                });
            });
        });
    }

    function onSearch() {
        var box = hero.querySelector('[data-faqx-results]');
        if (!box) return;
        var term = (input.value || '').trim().toLowerCase();

        if (term.length < 2) {
            clearSearchUI();
            return;
        }

        hero.classList.add('is-searching');
        box.hidden = false;
        box.innerHTML = '';

        var qHits = [];
        var aHits = [];
        index.forEach(function (rec) {
            if (rec.q.indexOf(term) !== -1) qHits.push(rec);
            else if (rec.a.indexOf(term) !== -1) aHits.push(rec);
        });
        var hits = qHits.concat(aHits).slice(0, 40);

        if (!hits.length) {
            var support = hero.getAttribute('data-support') || '';
            var empty = document.createElement('div');
            empty.className = 'faqx-results__empty';
            empty.innerHTML = 'No matches found.' + (support
                ? ' Email us at <a href="mailto:' + support + '">' + support + '</a> and we’ll help you out.'
                : '');
            box.appendChild(empty);
            return;
        }

        var meta = document.createElement('p');
        meta.className = 'faqx-results__meta';
        meta.textContent = hits.length + (hits.length === 1 ? ' answer found' : ' answers found');
        box.appendChild(meta);

        hits.forEach(function (rec) {
            var clone = rec.el.cloneNode(true);
            stripEditorAttrs(clone);
            clone.removeAttribute('id');
            $all('[id]', clone).forEach(function (el) { el.removeAttribute('id'); });
            clone.classList.remove('is-open');
            clone.style.setProperty('--faqx-accent', rec.color);

            var chip = document.createElement('span');
            chip.className = 'faqx-chip';
            chip.textContent = rec.topic;
            var qBtn = clone.querySelector('[data-faqx-q]');
            clone.insertBefore(chip, qBtn);

            highlight(clone.querySelector('.faqx-item__qtext'), term);
            box.appendChild(clone);
        });
    }

    function clearSearchUI() {
        if (!hero) return;
        hero.classList.remove('is-searching');
        var box = hero.querySelector('[data-faqx-results]');
        if (box) { box.hidden = true; box.innerHTML = ''; }
    }

    function highlight(el, term) {
        if (!el) return;
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        var nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        nodes.forEach(function (node) {
            var text = node.nodeValue;
            var idx = text.toLowerCase().indexOf(term);
            if (idx === -1) return;
            var frag = document.createDocumentFragment();
            frag.appendChild(document.createTextNode(text.slice(0, idx)));
            var mark = document.createElement('mark');
            mark.textContent = text.slice(idx, idx + term.length);
            frag.appendChild(mark);
            frag.appendChild(document.createTextNode(text.slice(idx + term.length)));
            node.parentNode.replaceChild(frag, node);
        });
    }

    function debounce(fn, ms) {
        var t;
        return function () {
            clearTimeout(t);
            t = setTimeout(fn, ms);
        };
    }

    /* ---------- theme editor support ---------- */
    document.addEventListener('shopify:section:load', function () { init(); });
    document.addEventListener('shopify:block:select', function (e) {
        var topic = e.target && e.target.closest ? e.target.closest('[data-faqx-topic]') : null;
        if (topic) {
            var slug = topic.getAttribute('data-slug');
            if (current !== slug) activate(slug, false);
        }
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
